module.exports = __webpack_public_path__ + "media/images/admin/icons/photo_library-269e6d45895325f41ed733f13c8313bd.png";